import { useEffect } from "react";
import { useRequest } from "ahooks";
import OrderDTO from "@/dto/order/OrderDTO";
import { cancelDropshippingRefund } from "@/services/api/dropShipping/refund";
import { Modal } from "antd";
import { useOrderManagementStore } from "@/scenes/OrderManagement/store/OrderManagementStore";

const useCancelDropshippingRefundRequest = (order: OrderDTO) => {
    const orderManagementStore = useOrderManagementStore();

    const request = useRequest(
        async () => {
            const retailerOrderId = order.id;

            const retailerShopId = order.shopId;

            const data = await cancelDropshippingRefund(retailerShopId, { retailerOrderId, retailerShopId });

            Modal.success({ title: "已撤销代发退款" });

            return data;
        },
        { manual: true },
    );

    useEffect(() => {
        if (request.data) {
            orderManagementStore.table.updateOrder(order.id, { retailerDropShippingInfo: request.data });
        }
    }, [request.data]);

    return request;
};

export default useCancelDropshippingRefundRequest;
